<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="p1"></a> Copyright © 2014 by James Carroll</p>
<p class="timebreak"> <br/></p>
<p class="center"><a id="px0"></a> All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center">The Library of Congress has cataloged the print edition as follows:<br/>
Carroll, James, date.<br/>
Warburg in Rome / James Carroll.</p>
<p class="center">pages cm</p>
<p class="center"><span style="font-size: smaller">ISBN</span> 978-0-547-73890-1 (hardback)</p>
<p class="center">1. World War, 1939–1945—Jews—Rescue—Fiction. 2. World War, 1939–1945—Civilian relief—Fiction. 3. Rescue work—Europe—History—20th century—Fiction. 4. War relief—Europe—History—20th century—Fiction. 5. Rome—Fiction. I. Title.</p>
<p class="center"><span style="font-size: smaller">PS</span>3553.<span style="font-size: smaller">A</span>764<span style="font-size: smaller">W</span>37 2014</p>
<p class="center">813'.54—dc23</p>
<p class="center">2013046582</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-547-73895-6<br/>
v1.0714</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?920b7a90